import React from 'react';
import LocationTemplate from './LocationTemplate';

const LumbertonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Lumberton"
      stateName="North Carolina"
      countyName="Robeson"
      zipCodes={["28358", "28359", "28360"]}
      latitude={34.6182}
      longitude={-79.0086}
      population={20681}
      historicalFact="County seat of Robeson County, named for the lumber industry that drove its early economy."
      nearbyTowns={[
        "Pembroke, NC",
        "Fairmont, NC",
        "Red Springs, NC",
        "Maxton, NC",
        "Laurinburg, NC",
        "Elizabethtown, NC",
        "Florence, SC",
        "Fayetteville, NC"
      ]}
    />
  );
};

export default LumbertonPage;